/* tq-cart · quantity and remove without a page reload.
   Changes go to /cart/change.js by line number; the section then re-renders
   from Shopify (Section Rendering API) so prices and discounts are always
   Shopify's own. Without JS the form posts normally. */
(() => {
  const root = () => document.querySelector('[data-tq-cart]');
  if (!root()) return;
  let busy = false;

  async function change(line, quantity) {
    if (busy) return;
    busy = true;
    const el = root();
    el.classList.add('is-busy');
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      const cart = await r.json();
      if (!r.ok) throw new Error(cart.description || cart.message || 'Could not update the cart.');
      const html = await (await fetch(`${location.pathname}?section_id=${el.dataset.section}`)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-tq-cart]');
      if (fresh) el.replaceWith(fresh);
      document.querySelectorAll('.tq-header__count').forEach((c) => { c.textContent = cart.item_count; c.hidden = !cart.item_count; });
      const s = root().querySelector('[data-cart-status]');
      if (s) s.textContent = 'Cart updated. ' + cart.item_count + (cart.item_count === 1 ? ' item.' : ' items.');
    } catch (e) {
      alert(e.message);
    } finally {
      busy = false;
      if (root()) root().classList.remove('is-busy');
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-tq-cart] [data-qty], [data-tq-cart] [data-remove]');
    if (!btn) return;
    const li = btn.closest('[data-line]');
    if (!li) return;
    e.preventDefault();
    const input = li.querySelector('.tq-qty__input');
    const q = btn.hasAttribute('data-remove') ? 0 : Math.max(0, (parseInt(input.value, 10) || 0) + Number(btn.dataset.qty));
    change(Number(li.dataset.line), q);
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-tq-cart] .tq-qty__input');
    if (!input) return;
    const li = input.closest('[data-line]');
    change(Number(li.dataset.line), Math.max(0, parseInt(input.value, 10) || 0));
  });

  // Enter in a quantity box should update, not jump to checkout.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches('[data-tq-cart] .tq-qty__input')) { e.preventDefault(); e.target.blur(); }
  });
})();
